import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'
import { TimeUtils } from '@front/volcanion/utils'
import { TextCell } from '@abra/elements/table/cells/basics'

const Row = ({ row }) => <>
  <TableCell size='small' sx={{ minWidth: 100 }}>
    <TextCell value={row?.code} />
  </TableCell>
  <TableCell size='small' sx={{ minWidth: 150 }}>
    <TextCell value={row?.companyservice?.contract?.company?.name} />
  </TableCell>
  <TableCell size='small' sx={{ minWidth: 150 }}>
    <TextCell value={row?.companyservice?.client_id} />
  </TableCell>
  <TableCell size='small' sx={{ minWidth: 150 }}>
    <TextCell value={row?.schedule?.name} />
  </TableCell>
  <TableCell size='small' sx={{ width: 90 }}>
    <TextCell value={row?.max_user_usage} />
  </TableCell>
  <TableCell size='small' sx={{ width: 90 }}>
    <TextCell value={row?.max_global_usage} />
  </TableCell>
  <TableCell size='small' sx={{ width: 80 }}>
    <TextCell value={row?.amount} />
  </TableCell>
  <TableCell size='small' sx={{ width: 80 }}>
    <TextCell value={row?.active ? I18n.t('status.active') : I18n.t('status.inactive')} sx={{ color: row?.active ? 'green' : 'orange' }} />
  </TableCell>
  <TableCell size='small' sx={{ width: 100 }}>
    <TextCell value={TimeUtils.formatDateBackToFront(row?.createdAt)} />
  </TableCell>
  <TableCell size='small' sx={{ minWidth: 120 }}>
    <TextCell value={_.join(_.compact([row?.createdBy?.info?.first_name, row?.createdBy?.info?.last_name]), ' ')} />
  </TableCell>
</>

export default React.memo(Row)
